export default __webpack_public_path__ + "static/media/refresh-white.70cf53db.svg";